import { EventType } from "public_app/events/entity";
var CookieConsentUIContextDefaults = {
    cookieMeasurement: false,
    cookieMarketing: false,
    consentGiven: false,
};
var MemberUIContextDefaults = {
    id: 0,
    isMember: false,
    userMemberIdt: null,
    hasAccess: false,
    divisionId: 0,
    clubId: null
};
var EmailUIContextDefaults = {
    email: "",
    isKnownEmail: false,
    isLoggedWithThisEmail: false,
};
var EventPlanningUIContextDefaults = {
    isOrganizer: false,
    isForeignAdjudicatorApprover: false,
    isCompetitionLead: false,
    isCompetitionCommissioner: false,
    isScrutineerLead: false,
    isSecretary: false,
    isSportVicepresident: false,
    isGeneralInvigilator: false,
    canCancel: false,
    canRegisterCompetitors: false,
    canChangeRegistrationTimes: false,
};
var EventRegistrationUIContextDefaults = {
    eventType: EventType.Competition,
    id: 0,
    date: null,
    isClub: false,
    attendees: [],
    isCompetitionLead: false,
    isLeadScrutineer: false,
    isScrutineer: false,
};
var AdminWebCredentialsUIContextDefaults = {};
export { CookieConsentUIContextDefaults, MemberUIContextDefaults, EmailUIContextDefaults, EventPlanningUIContextDefaults, EventRegistrationUIContextDefaults, AdminWebCredentialsUIContextDefaults, };
